import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid3x3, Maximize2, ZoomIn, ZoomOut } from 'lucide-react';
import clsx from 'clsx';

import { useMediaStudio } from '../../context/MediaStudioContext';

import scss from './WorkspaceChrome.module.scss';

function WorkspaceChrome() {
  const { t } = useTranslation('mediaStudio');
  const { features, editor, viewport } = useMediaStudio();
  const gridEnabled = editor.ui.gridEnabled;
  const percent = Math.round(viewport.relativeZoom * 100);

  if (!features.zoomPan && !features.grid) {
    return null;
  }

  return (
    <div className={scss.bar}>
      {features.zoomPan ? (
        <div className={scss.group}>
          <button type='button' className={scss.button} onClick={viewport.zoomOut} title={t('zoomOut')}>
            <ZoomOut size={16} />
          </button>
          <span className={scss.zoomLabel}>{percent}%</span>
          <button type='button' className={scss.button} onClick={viewport.zoomIn} title={t('zoomIn')}>
            <ZoomIn size={16} />
          </button>
          <button type='button' className={scss.button} onClick={viewport.fit} title={t('zoomFit')}>
            <Maximize2 size={16} />
          </button>
        </div>
      ) : null}

      {features.grid ? (
        <div className={scss.group}>
          <button
            type='button'
            className={clsx(scss.button, gridEnabled && scss.active)}
            onClick={() => editor.setUi({ gridEnabled: !gridEnabled })}
            title={t('toggleGrid')}>
            <Grid3x3 size={16} />
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default WorkspaceChrome;
